/* eslint no-restricted-properties: off */
import { IEnvironment } from 'my-poppies-b2b-types';

import { allowedEnvironments } from '@/config';

export const envVarConfig = {
  NEXT_PUBLIC_APP_ENV: {
    retrieve: () => process.env.NEXT_PUBLIC_APP_ENV,
    transform: (rawValue: string) => rawValue as IEnvironment,
    validate: (value: IEnvironment) => allowedEnvironments.includes(value),
    invalidValueErrorMsg: `must be one of ${allowedEnvironments.join(', ')}`,
  },
  NEXT_PUBLIC_HANKO_API_URL: {
    retrieve: () => process.env.NEXT_PUBLIC_HANKO_API_URL,
    transform: (rawValue: string) => rawValue as IEnvironment,
    validate: (value: IEnvironment) => value.startsWith('https://'),
    invalidValueErrorMsg: `must be a valid url`,
  },
  NEXT_PUBLIC_BACKEND_BASE_URL: {
    retrieve: () => process.env.NEXT_PUBLIC_BACKEND_BASE_URL,
    transform: (rawValue: string) => rawValue as IEnvironment,
    validate: (value: IEnvironment) => value.startsWith('https://'),
    invalidValueErrorMsg: `must be a valid url`,
  },
  NEXT_PUBLIC_SKIP_ROUTE_PROTECTOR: {
    retrieve: () => process.env.NEXT_PUBLIC_SKIP_ROUTE_PROTECTOR,
    transform: (value: string): boolean => value === 'true',
    validate: (value: boolean) => typeof value === 'boolean',
    invalidValueErrorMsg: `must be a boolean`,
  },
  NEXT_PUBLIC_SKIP_LOADING_GUARD: {
    retrieve: () => process.env.NEXT_PUBLIC_SKIP_LOADING_GUARD,
    transform: (value: string): boolean => value === 'true',
    validate: (value: boolean) => typeof value === 'boolean',
    invalidValueErrorMsg: `must be a boolean`,
  },
  NEXT_PUBLIC_FAKE_AUTHENTICATED: {
    retrieve: () => process.env.NEXT_PUBLIC_FAKE_AUTHENTICATED,
    transform: (value: string): boolean => value === 'true',
    validate: (value: boolean) => typeof value === 'boolean',
    invalidValueErrorMsg: `must be a boolean`,
  },
  NEXT_PUBLIC_COMMIT_HASH: {
    retrieve: () => process.env.NEXT_PUBLIC_COMMIT_HASH,
    transform: (rawValue: string) => rawValue,
    validate: (value: string) => typeof value === 'string',
    invalidValueErrorMsg: `must be a string`,
  },
  NEXT_PUBLIC_REF_NAME: {
    retrieve: () => process.env.NEXT_PUBLIC_REF_NAME,
    transform: (rawValue: string) => rawValue,
    validate: (value: string) => typeof value === 'string',
    invalidValueErrorMsg: `must be a string`,
  },
  NEXT_PUBLIC_COMMIT_TIMESTAMP: {
    retrieve: () => process.env.NEXT_PUBLIC_COMMIT_TIMESTAMP,
    transform: (rawValue: string) => rawValue,
    validate: (value: string) => typeof value === 'string',
    invalidValueErrorMsg: `must be a string`,
  },
  NEXT_PUBLIC_BUILD_TIMESTAMP: {
    retrieve: () => process.env.NEXT_PUBLIC_BUILD_TIMESTAMP,
    transform: (rawValue: string) => rawValue,
    validate: (value: string) => typeof value === 'string',
    invalidValueErrorMsg: `must be a string`,
  },
};
